// File: StartupPlanningCSR.jsx
import React from "react";

export default function StartupPlanningCSR() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Startup Planning & CSR
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks supports startups and corporates with planning and CSR compliance.
          </p>
          <p className="text-gray-700">
            Complete startup planning services including pitch deck creation, DPIIT registration, business structuring, funding strategy, plus CSR-1 registration, policy formulation, and Companies Act compliance for eligible corporates.
          </p>
        </div>

        {/* Right: Image (STARTUP PLANNING & CSR SPECIFIC) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3184409/pexels-photo-3184409.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Startup planning and CSR compliance services by Hawkins & Brooks"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation for startup planning and CSR registration.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Business plans & pitch deck drafts</li>
                <li>CIN, PAN, financials for CSR</li>
                <li>Board resolutions & policies</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Strategic and regulatory alignment for startups and CSR compliance.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Startup Strategy Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete startup ecosystem support including pitch deck design (problem-solution-market traction-ask), DPIIT recognition, entity structuring (Pvt Ltd/LLP/OPC), funding roadmap, valuation modeling, and investor readiness preparation.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  CSR Compliance Mastery
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise CSR-1 MCA registration (within 30 days of eligibility), CSR policy formulation, committee constitution, spend tracking (2% PAT), impact reporting (Form CSR-2), project approvals, and Companies Act Section 135 compliance ensuring zero penalties.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Strategic Alignment
                </h3>
                <p className="text-gray-700 text-sm">
                  Full-service planning from business model canvas through pitch deck refinement, DPIIT/80-IAC applications, CSR committee setup, spend optimization, compliance audits, impact measurement, and strategic advisory aligning growth with regulatory requirements.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
